export default "__VITE_ASSET__BgWetG2C__"